import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useTranslation } from '../i18n/I18nContext';
import QoldoLogo from './QoldoLogo';

/**
 * Screen shown when a course is unpublished or unavailable
 */
export default function UnavailableScreen({ message }) {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <Card className="w-full max-w-md text-center">
        <CardContent className="py-12">
          <QoldoLogo className="mb-6" />
          <AlertTriangle className="h-16 w-16 text-amber-500 mx-auto mb-6" />
          <h1 className="text-2xl font-bold mb-4">{t('unavailable_title')}</h1>
          <p className="text-gray-600">
            {message || t('unavailable_title')}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
